import { useMediaQuery } from "react-responsive";
import { Button } from "../../Button";

import { StyledContainer, Title, Description } from "./styles";

export function Call({ onAction }) {
  const isLargeDesktop = useMediaQuery({ query: "(min-width: 1160px)" });

  return (
    <StyledContainer>
      <Title highlightText={!isLargeDesktop}>Helping your costs go down.</Title>
      <Description highlightText={!isLargeDesktop}>Description for the Jumbo</Description>
      <Button onClick={onAction}>What do we do?</Button>
    </StyledContainer>
  );
}
